class Filters {
  constructor() {
    this.selectors = {
      component: '.filters__form',
      clearButton: '.filters__form [type="reset"]',
    };
  }

  // BE will add 'selected' attribute to the last selected option
  // On 'reset' click, JS will remove the attributes
  // reset the select2 inputs aliases values
  // trigger a submit to re-present the unfiltered items
  handleClear() {
    $(this.selectors.clearButton).on('click', (event) => {
      const filtersFormSelects = $(event.currentTarget)
        .closest(this.selectors.component)
        .find('select');

      filtersFormSelects.find('option:selected').removeAttr('selected');
      filtersFormSelects.val('').trigger('change');

      $(event.currentTarget).closest(this.selectors.component).submit();
    });
  }

  init() {
    this.handleClear();
  }
}

export default new Filters();
